module.exports = __webpack_public_path__ + "static/img/swiper5.ef018eac.png";